import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Confetti from "react-dom-confetti";
// import Confetti from "react-confetti";
import { useTheme } from "@mui/material/styles";
import { createTheme, responsiveFontSizes, ThemeProvider } from "@mui/material/styles";
import {
  Box,
  Button,
  ButtonBase,
  Chip,
  Divider,
  Fade,
  IconButton,
  Grid,
  Slide,
  Stack,
  TextField,
  TextareaAutosize,
  Typography,
} from "@mui/material";
import { AddCircle, ArrowBackIosNew, RemoveCircle } from "@mui/icons-material";
import { getAdaptivFontSize, getRoute } from "../utils/CommonUtils";
import { accuracyToRank } from "../utils/PoseUitils";
import { AppSingleton, data_list } from "../services/user_config";

const defaultConfig = {
  angle: 90,
  spread: 360,
  startVelocity: 40,
  elementCount: 50,
  dragFriction: 0.12,
  duration: 3000,
  stagger: 3,
  width: "10px",
  height: "10px",
  colors: ["#a864fd", "#29cdff", "#78ff44", "#ff718d", "#fdff6a"],
};

// const defaultConfig = {
//   friction: 0.12,
//   tweenDuration: 3000,
//   initialVelocityX: 40,
//   initialVelocityY: 40,
//   gravity: 1.0,
//   confettiSource: {
//     x: 0,
//     y: 0,
//     w: 10,
//     h: 10,
//   },
//   width: window.innerWidth,
//   height: window.innerHeight,
//   colors: ["#a864fd", "#29cdff", "#78ff44", "#ff718d", "#fdff6a"],
// };

const ResultPage = () => {
  const { data } = useParams();
  const navigate = useNavigate();
  const theme = useTheme();
  const [result, setResult] = useState({ score: 0, accuracy: 0 });
  const [confettiConfig, setConfettiConfig] = React.useState({});
  const [confettiLeftConfig, setConfettiLeftConfig] = React.useState({});
  const [confettiRightConfig, setConfettiRightConfig] = React.useState({});
  const scoreElRef = useRef(null);
  const accuracyElRef = useRef(null);

  useEffect(() => {
    // console.log(data);
    const decodedBase64String = decodeURIComponent(data);
    const { score, accuracy } = JSON.parse(atob(decodedBase64String));
    setResult({ score, accuracy });

    // setConfettiConfig({...defaultConfig, position: "fixed", })
    // setConfettiActive(true);
    // setTimeout(() => {
    // setConfettiActive(false);
    // }, 3000); // Reset confetti after 3 seconds
  }, []);

  // const [checked, setChecked] = useState(true);

  return (
    <Box
      sx={{
        width: "100%",
        // height: "100vh",
        backgroundColor: theme.palette.background.main,
        // overflow: "hidden",
      }}
    >
      {/* <Box sx={{ position: "absolute", width: "100%", backgroundColor: theme.palette.card.main }}> */}
      <Box sx={{ width: "100%", backgroundColor: theme.palette.card.main }}>
        <Fade in={true} mountOnEnter unmountOnExit>
          <Box sx={{ width: "100%" }}>
            <Typography
              sx={{
                textAlign: "center",
                fontSize: getAdaptivFontSize(window.screen.width < 768 ? getAdaptivFontSize(30) : getAdaptivFontSize(60)),
              }}
            >
              訓練結束
            </Typography>
          </Box>
        </Fade>
      </Box>
      <Box
        sx={{
          width: "100%",
          // , pt: "11vh"
        }}
      >
        <Slide direction="up" in={true} mountOnEnter unmountOnExit>
          <Box sx={{ width: "100%" }}>
            <Typography
              sx={{
                textAlign: "center",
                fontSize: getAdaptivFontSize(window.screen.width < 768 ? getAdaptivFontSize(24) : getAdaptivFontSize(48)),
              }}
            >
              得分
            </Typography>
            <Divider sx={{ ml: 8, mr: 8 }} />
          </Box>
        </Slide>
        <Stack spacing={2} sx={{ mt: 4 }}>
          <Fade
            in={true}
            {...{ timeout: 1500 }}
            style={{ transitionDelay: "500ms" }}
            onEnter={() => {
              setTimeout(() => {
                const { top, left, width, height } = accuracyElRef.current.getBoundingClientRect();
                const x = left + width / 2;
                const y = top + height / 2;
                // console.log(`x: ${x}, y: ${y}`);
                setConfettiConfig({ ...defaultConfig, style: { position: "fixed", x: "99px", y: "555px" } });
                // setConfettiLeftConfig({ ...defaultConfig, position: "absolute", top: 16, left: 16 });
                // setConfettiRightConfig({ ...defaultConfig, position: "absolute", top: 16, right: 16 });
              }, 500);
            }}
            mountOnEnter
            unmountOnExit
          >
            <Box sx={{ width: "100%" }}>
              <Typography
                ref={scoreElRef}
                sx={{
                  textAlign: "center",
                  fontSize: getAdaptivFontSize(window.screen.width < 768 ? getAdaptivFontSize(24) : getAdaptivFontSize(48)),
                }}
              >
                {`得分: ${result?.score ?? 0}`}
              </Typography>
            </Box>
          </Fade>
          <Fade in={true} {...{ timeout: 1500 }} style={{ transitionDelay: "1500ms" }} mountOnEnter unmountOnExit>
            <Box sx={{ width: "100%" }}>
              <Typography
                ref={accuracyElRef}
                sx={{
                  textAlign: "center",
                  fontSize: getAdaptivFontSize(window.screen.width < 768 ? getAdaptivFontSize(24) : getAdaptivFontSize(48)),
                }}
              >
                {`A.I.評分: ${accuracyToRank(result?.accuracy ?? 0)}`}
              </Typography>
            </Box>
          </Fade>
        </Stack>

        <Fade in={true} {...{ timeout: 1000 }} style={{ transitionDelay: "3500ms" }}>
          <Box
            sx={{
              mt: 8,
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Button
              variant="contained"
              sx={{ borderRadius: "24px", boxShadow: 15 }}
              onClick={() => {
                navigate(`${getRoute("listing-page")}/`);
              }}
            >
              <Typography variant="h5" sx={{ pt: 2, pb: 2, pl: 8, pr: 8 }}>
                再來一次
              </Typography>
            </Button>
          </Box>
        </Fade>
      </Box>

      <Confetti active={Object.keys(confettiConfig).length > 0} config={confettiConfig} />
      {/* <Confetti {...defaultConfig} /> */}
    </Box>
  );
};

const f = () => {};

export { ResultPage, f };
